import {
  combineReducers,
  Store,
  applyMiddleware,
  legacy_createStore as createStore,
} from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import {
  IKlantGroepState,
  IKlantKoppelingState,
  IVolumewaardeState,
  IGlobalState,
  IKoppelingenVestigingenState,
  IGlnLocatiesPerVestigingState,
  IGlnLocatieZoekState,
  IAarCombinatiesState,
  IAarZonderLocatieState,
  IProductDimensionState,
} from './interfaces'
import { klantGroepenReducer } from './reducers/klantGroepenReducer'
import { klantKoppelingReducer } from './reducers/klantKoppelingReducer'
import { glnLocatieZoekReducer } from './reducers/glnLocatieZoekReducer'
import { volumewaardenReducer } from './reducers/volumewaardenReducer'
import { koppelingenVestigingenReducer } from './reducers/koppelingenVestigingenReducer'
import { glnLocatiesPerVestigingReducer } from './reducers/glnLocatiesPerVestigingReducer'
import { globalReducer } from './reducers/globalReducer'
import { aarCombinatiesReducer } from './reducers/aarCombinatiesReducer'
import { aarZonderLocatieReducer } from './reducers/aarZonderLocatieReducer'
import { productDimensionReducer } from './reducers/productDimensionReducer'

const applicationReducer = combineReducers<IApplicationState>({
  aarCombinatiesState: aarCombinatiesReducer,
  aarZonderLocatieState: aarZonderLocatieReducer,
  klantGroepState: klantGroepenReducer,
  klantKoppelingState: klantKoppelingReducer,
  volumewaardeState: volumewaardenReducer,
  koppelingenVestigingenState: koppelingenVestigingenReducer,
  glnLocatiesPerVestigingState: glnLocatiesPerVestigingReducer,
  glnLocatieZoekState: glnLocatieZoekReducer,
  globalState: globalReducer,
  productDimensionState: productDimensionReducer,
})

export interface IApplicationState {
  readonly globalState: IGlobalState
  readonly aarCombinatiesState: IAarCombinatiesState
  readonly aarZonderLocatieState: IAarZonderLocatieState
  readonly klantGroepState: IKlantGroepState
  readonly klantKoppelingState: IKlantKoppelingState
  readonly volumewaardeState: IVolumewaardeState
  readonly koppelingenVestigingenState: IKoppelingenVestigingenState
  readonly glnLocatiesPerVestigingState: IGlnLocatiesPerVestigingState
  readonly glnLocatieZoekState: IGlnLocatieZoekState
  readonly productDimensionState: IProductDimensionState
}

export function configureStore(): Store<IApplicationState> {
  const store = createStore(
    applicationReducer,
    composeWithDevTools(applyMiddleware(thunk))
  )
  return store
}
